import { Content } from '../models';
import ApiResource from './ApiResource';

class ContentResource extends ApiResource<Content> {
  public endpoint = '/page_contents';
}

export const contentResource = new ContentResource();
